import { render, staticRenderFns } from "./DhmeWkbChapterDialog.vue?vue&type=template&id=34e03801&scoped=true"
import script from "./DhmeWkbChapterDialog.vue?vue&type=script&lang=js"
export * from "./DhmeWkbChapterDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e03801",
  null
  
)

export default component.exports